import { Component, inject, OnInit } from '@angular/core';
import { ActuatorInfoService } from 'lion-api';
import { CustomerStore, UserStore } from '@shared/data';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: false
})
export class FooterComponent implements OnInit {
  version? = '';
  private actuatorInfoService = inject(ActuatorInfoService);
  protected userStore = inject(UserStore);
  protected customerStore = inject(CustomerStore);
  protected isCorporateMode = this.userStore.isCorporateMode;

  ngOnInit() {
    this.actuatorInfoService.actuatorInfoGet().subscribe({
      next: (value) => {
        this.version = value.version?.replace('-SNAPSHOT', '');
      }
    });
  }

  get hotlineKey(): string {
    if (this.isCorporateMode() || this.userStore.isFkDzTrader()) {
      const salesUnit = this.customerStore.customer()?.salesUnit;
      if (salesUnit) {
        return `shared.footer.hotlineNumber_${salesUnit}`;
      }

      const userGruppe = this.userStore.userGruppe();
      if (userGruppe) {
        return `shared.footer.hotlineNumber_${userGruppe}`;
      }
    }
    return 'shared.footer.hotlineNumber';
  }
}
